import React from "react";
import LogUtil from "./util/LogUtil";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import NavegadorUtil from "./util/NavegadorUtil";
import { ReactComponent as ImagemMenuBack } from "./assets/images/icons/menu-back.svg";
import { ReactComponent as ImagemEntre } from "./assets/images/icons/menu/log-in.svg";
import { ReactComponent as ImagemInspirese } from "./assets/images/icons/menu/inspirese.svg";
import { ReactComponent as ImagemLojas } from "./assets/images/icons/menu/lojas.svg";
import { ReactComponent as ImagemAjuda } from "./assets/images/icons/menu/help-circle.svg";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import Carregando from "./components/Carregando";

interface IMenuProps extends RouteComponentProps {}

class Menu extends React.Component<IMenuProps, any> {
  componentWillMount(): void {
    if (AppState.getUsuarioLogado() !== null) {
      NavegadorUtil.redirect("/menu-logado", this.props.history);
    }
  }

  componentDidMount(): void {
    LogUtil.logPage("Menu");

    if (AppState.getUsuarioLogado() !== null) {
      NavegadorUtil.redirect("/menu-logado", this.props.history);
    }
  }

  render(): any {
    return (
      <section className="menu">
        <div className="header">
          <div className="back" onClick={() => this.props.history.goBack()}>
            <ImagemMenuBack />
          </div>
        </div>
        <ul>
          <li>
            <Link to={NavegadorUtil.getUrl("/login")}>
              <ImagemEntre /> Entre / Cadastre-se
            </Link>
            <span>Seja um Cliente Bem Querer</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/inspirese")}>
              <ImagemInspirese /> Inspire-se
            </Link>
            <span>Dicas, receitas e listas especiais!</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/lojas")}>
              <ImagemLojas /> Lojas
            </Link>
            <span>Encontre o Oba mais perto de você.</span>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/ajuda")}>
              <ImagemAjuda /> Ajuda
            </Link>
          </li>
          <li>
            <Link to={NavegadorUtil.getUrl("/ajuda/cliente-bem-querer")}>
              Cliente Bem Querer
            </Link>
          </li>
        </ul>
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={false} concluido={true}></Carregando>
      </section>
    );
  }
}

export default withRouter(Menu);
